/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 * @Date: 2021-01-24 16:34:47
 * @LastEditTime: 2021-01-24 16:37:48
 */
const i18n = {
  'zh-CN': {
    therequestfailed: '请求失败',
    backMall: '导入/导出',
    currentlist: '将为您导出当前列表的全部数据',
    currentFilter: '将为您导出当前筛选结果的全部数据',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteInformation: '确定删除信息吗?',
    successfullyDelete: '删除成功',
    selectedInformation: '确定删除所选信息吗?',
    create: '新建',
    edit: '编辑',
    submission: '提交中',
    submitSuccessfully: '提交成功!',
    back: '返回'
  },
  'en': {
    therequestfailed: 'Request failed',
    backMall: 'Import/Export',
    currentlist: 'All the data of the current list will be exported for you',
    currentFilter: 'All the data of the current filtered result will be exported for you',
    tip: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteInformation: 'Confirm to delete the information?',
    successfullyDelete: 'Deleted successfully',
    selectedInformation: 'Confirm to delete the selected information?',
    create: 'New',
    edit: 'Edit',
    submission: 'Submitting',
    submitSuccessfully: 'Submitted successfully!',
    back: 'Back'
  }
}
export default i18n
